var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageMonthlySalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.4152V19.25C0 20.7668 3.69531 22 8.25 22C12.8047 22 16.5 20.7668 16.5 19.25V17.4152C14.7254 18.6656 11.4812 19.25 8.25 19.25C5.01875 19.25 1.77461 18.6656 0 17.4152ZM13.75 5.5C18.3047 5.5 22 4.2668 22 2.75C22 1.2332 18.3047 0 13.75 0C9.19531 0 5.5 1.2332 5.5 2.75C5.5 4.2668 9.19531 5.5 13.75 5.5ZM0 12.9078V15.125C0 16.6418 3.69531 17.875 8.25 17.875C12.8047 17.875 16.5 16.6418 16.5 15.125V12.9078C14.7254 14.3687 11.477 15.125 8.25 15.125C5.02305 15.125 1.77461 14.3687 0 12.9078ZM17.875 13.3805C20.3371 12.9035 22 12.0184 22 11V9.16523C21.0031 9.86992 19.5379 10.3512 17.875 10.6477V13.3805ZM8.25 6.875C3.69531 6.875 0 8.41328 0 10.3125C0 12.2117 3.69531 13.75 8.25 13.75C12.8047 13.75 16.5 12.2117 16.5 10.3125C16.5 8.41328 12.8047 6.875 8.25 6.875ZM17.673 9.29414C20.2512 8.83008 22 7.91914 22 6.875V5.04024C20.4746 6.11875 17.8535 6.69883 15.0949 6.83633C16.3625 7.45078 17.2949 8.27578 17.673 9.29414Z",
    fill: "#118F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageMonthlySalary);
export default __webpack_public_path__ + "static/media/AVERAGE_MONTHLY_SALARY.22435f1ca011efaa7068fdc751f8a914.svg";
export { ForwardRef as ReactComponent };